import React from "react";

const features = [
  {
    name: "Find Connections",
    desc: "Connect with support groups and families based on shared experiences, interests, and location using our easy-to-navigate filters. Find the people who truly understand your journey.",
    iconColor: "text-sky-blue",
    icon: (
      <path
        strokeLinecap="round"
        d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
      />
    ),
  },
  {
    name: "Verified Resources",
    desc: "Access trusted neurodivergent family therapists and resources in your area.",
    iconColor: "text-heart-teal",
    icon: (
      <path
        strokeLinecap="round"
        d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
      />
    ),
  },
  {
    name: "Local Events",
    desc: "Discover neurodiversity events and activities that bring online connections into real life.",
    iconColor: "text-sky-blue",
    icon: (
      <>
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <path strokeLinecap="round" d="M16 2v4M8 2v4M3 10h18" />
      </>
    ),
  },
  {
    name: "Safe Community",
    desc: "Share experiences in a moderated, supportive environment designed for the neurodivergent community.",
    iconColor: "text-sunshine",
    icon: (
      <path
        strokeLinecap="round"
        d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM9 12l2 2 4-4"
      />
    ),
  },
];

/**
 * Features grid — Stitch our-app.html §3 (no carousel; static 2×2)
 */
const Ourfeatures = () => {
  return (
    <section
      id="features"
      className="py-16 sm:py-20 md:py-24 bg-surface-white relative text-left"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="flex flex-col items-start mb-10 sm:mb-16 max-w-3xl">
          <span className="inline-block px-3.5 py-1 rounded-full bg-cloud-mist text-spectrum-blue text-xs font-headline font-bold tracking-wider mb-4">
            OUR FEATURES
          </span>
          <h2 className="font-headline text-2xl sm:text-3xl lg:text-4xl text-ink tracking-tight">
            <span className="font-light">Trusted Connections &amp;</span>
            <span className="font-extrabold block text-spectrum-blue">
              Local Growth
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-8">
          {features.map((item) => (
            <article
              key={item.name}
              className="p-6 sm:p-8 rounded-brand border border-cloud-mist hover:shadow-brand-sm transition-all duration-300 flex flex-col group"
              style={{
                backgroundColor:
                  "color-mix(in srgb, var(--color-cloud-mist) 40%, var(--color-white))",
              }}
            >
              <div className="w-12 h-12 rounded-brand bg-surface-white flex items-center justify-center shadow-sm mb-5 sm:mb-6 group-hover:scale-105 transition-transform">
                <svg
                  className={item.iconColor}
                  fill="none"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  aria-hidden="true"
                >
                  {item.icon}
                </svg>
              </div>
              <h3 className="font-headline font-bold text-lg sm:text-xl text-spectrum-blue mb-3">
                {item.name}
              </h3>
              <p className="font-body text-[15px] sm:text-base text-muted leading-relaxed">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ourfeatures;
